<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" fill-rule="evenodd" stroke="#000" d="M2.25 13.286h3.047V21h13.406v-7.714h3.047L12 3 2.25 13.286z" clip-rule="evenodd"/>
</svg>
